"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _utils = require("@seedlang/utils");
var _lodash = require("lodash");
var _state = require("@seedlang/state");
var _constants = require("@seedlang/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var SynonymCardWrapper = function SynonymCardWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "multipleChoiceSelected", _descriptor, _this);
      _initializerDefineProperty(_this, "correct", _descriptor2, _this);
      _this.showSentenceHint = function (event) {
        var _event$stopPropagatio;
        event === null || event === void 0 || (_event$stopPropagatio = event.stopPropagation) === null || _event$stopPropagatio === void 0 || _event$stopPropagatio.call(event);
        _this.sentenceHintShown = true;
      };
      _this.onClick = function (option) {
        if (!_this.userCardIsUsable) {
          return;
        }
        if (!_state.DeckUI.reviewDeck && !_state.DeckUI.user.wasUiElementSeen('synonym')) {
          _state.DeckUI.designateUiElementAsSeen('synonym');
        }
        if (!_state.DeckUI.user.wasUiElementSeen('synonym-trainer-card-answered')) {
          _state.DeckUI.designateUiElementAsSeen('synonym-trainer-card-answered');
        }
        _this.multipleChoiceSelected = option.id;
        _this.props.cardState.selectedOptionText = option.value || option.id;
        _this.props.cardState.multipleChoiceOptionsText = _this.synonymOptionsText;
        if (option.correct) {
          _this.correct = true;
          _this.props.userCard.set('score', 1);
          _state.DeckUI.onCorrectAnswer(_this.props.card, _this.props.cardState, _this.props.userCard, {
            xp: 1,
            xpSlug: 'synonym'
          });
        } else {
          _this.props.userCard.set('seen', true);
          _state.DeckUI.onIncorrectAnswer(_this.props.card, _this.props.cardState, _this.props.userCard);
        }
        setTimeout(_this.clearSelection, 500);
        setTimeout(function () {
          return _state.DeckUI.reveal(_this.props.card, _this.props.cardState);
        }, 500);
      };
      _this.clearSelection = function () {
        _this.multipleChoiceSelected = null;
      };
      _this.synonymOptionsCache = [];
      _this.synonymOptionsCacheCardId = null;
      _state.DeckUI.enrichWord(_this.props.card);
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "sentenceHintShown",
      get: function get() {
        return this.props.cardState.sentenceHintShown;
      },
      set: function set(value) {
        this.props.cardState.set('sentenceHintShown', value);
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;
        this.disposeExampleReaction = (0, _mobx.reaction)(function () {
          var _this2$props$card, _this2$revealedWord, _this2$promptWord, _this2$exampleAssocia;
          return [(_this2$props$card = _this2.props.card) === null || _this2$props$card === void 0 ? void 0 : _this2$props$card.id, (_this2$revealedWord = _this2.revealedWord) === null || _this2$revealedWord === void 0 ? void 0 : _this2$revealedWord.id, (_this2$promptWord = _this2.promptWord) === null || _this2$promptWord === void 0 ? void 0 : _this2$promptWord.id, (_this2$exampleAssocia = _this2.exampleAssociation) === null || _this2$exampleAssocia === void 0 ? void 0 : _this2$exampleAssocia.meaningId].join(':');
        }, function () {
          _this2.sentenceHintShown = false;
        }, {
          fireImmediately: true
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        var _this$disposeExampleR;
        (_this$disposeExampleR = this.disposeExampleReaction) === null || _this$disposeExampleR === void 0 || _this$disposeExampleR.call(this);
      }
    }, {
      key: "example",
      get: function get() {
        var _word$rootWord,
          _this3 = this,
          _meaning,
          _meaning2;
        if (!_state.DeckUI.showVocabExampleSentences) {
          return;
        }
        var word = this.revealed ? this.revealedWord : this.promptWord;
        var meanings = (word !== null && word !== void 0 && (_word$rootWord = word.rootWord) !== null && _word$rootWord !== void 0 && _word$rootWord.id ? word.rootWord.meanings : word === null || word === void 0 ? void 0 : word.meanings) || [];
        var meaning;
        if (this.revealed) {
          meaning = meanings.find(function (item) {
            var _this3$exampleAssocia;
            return item.id === ((_this3$exampleAssocia = _this3.exampleAssociation) === null || _this3$exampleAssocia === void 0 ? void 0 : _this3$exampleAssocia.meaningId);
          });
        } else {
          var _matches$;
          var matches = meanings.flatMap(function (item) {
            return (item.synonymMatches || []).filter(function (match) {
              var _this3$revealedWord;
              return match.synonymId === ((_this3$revealedWord = _this3.revealedWord) === null || _this3$revealedWord === void 0 ? void 0 : _this3$revealedWord.id);
            }).map(function (match) {
              return {
                meaning: item,
                similarity: match.similarity
              };
            });
          });
          matches.sort(function (a, b) {
            var _b$similarity, _a$similarity;
            return ((_b$similarity = b.similarity) !== null && _b$similarity !== void 0 ? _b$similarity : -Infinity) - ((_a$similarity = a.similarity) !== null && _a$similarity !== void 0 ? _a$similarity : -Infinity);
          });
          meaning = ((_matches$ = matches[0]) === null || _matches$ === void 0 ? void 0 : _matches$.meaning) || meanings[0];
        }
        return {
          id: word === null || word === void 0 ? void 0 : word.id,
          languageId: word === null || word === void 0 ? void 0 : word.languageId,
          cardExampleSentence: (_meaning = meaning) === null || _meaning === void 0 ? void 0 : _meaning.highlightedExampleSentence,
          cardExampleTranslation: (_meaning2 = meaning) === null || _meaning2 === void 0 ? void 0 : _meaning2.highlightedExampleTranslation
        };
      }
    }, {
      key: "showSentenceHintButton",
      get: function get() {
        var _this$example;
        return !this.revealed && this.showPromptText && !this.sentenceHintShown && (0, _utils.isPresent)((_this$example = this.example) === null || _this$example === void 0 ? void 0 : _this$example.cardExampleSentence);
      }
    }, {
      key: "showExampleSentence",
      get: function get() {
        var _this$example2;
        return (this.revealed || this.showPromptText && this.sentenceHintShown) && (0, _utils.isPresent)((_this$example2 = this.example) === null || _this$example2 === void 0 ? void 0 : _this$example2.cardExampleSentence);
      }
    }, {
      key: "revealed",
      get: function get() {
        return this.props.cardState.revealed;
      }
    }, {
      key: "userCardIsUsable",
      get: function get() {
        var _this$props$userCard;
        return typeof ((_this$props$userCard = this.props.userCard) === null || _this$props$userCard === void 0 ? void 0 : _this$props$userCard.set) === 'function';
      }
    }, {
      key: "revealedWord",
      get: function get() {
        var _this$props$card;
        return (_this$props$card = this.props.card) === null || _this$props$card === void 0 ? void 0 : _this$props$card.word;
      }
    }, {
      key: "promptWord",
      get: function get() {
        return this.correctSynonym || this.revealedWord;
      }
    }, {
      key: "promptWordText",
      get: function get() {
        var _this$promptWord, _this$promptWord2;
        return ((_this$promptWord = this.promptWord) === null || _this$promptWord === void 0 ? void 0 : _this$promptWord.targetTextWithDefiniteArticle) || ((_this$promptWord2 = this.promptWord) === null || _this$promptWord2 === void 0 ? void 0 : _this$promptWord2.targetText);
      }
    }, {
      key: "promptWordHasVideoClip",
      get: function get() {
        var _this$promptWord3;
        return (0, _utils.isPresent)((_this$promptWord3 = this.promptWord) === null || _this$promptWord3 === void 0 || (_this$promptWord3 = _this$promptWord3.target) === null || _this$promptWord3 === void 0 ? void 0 : _this$promptWord3.videoClip);
      }
    }, {
      key: "correctSynonymHasVideoClip",
      get: function get() {
        var _this$revealedWord;
        return (0, _utils.isPresent)((_this$revealedWord = this.revealedWord) === null || _this$revealedWord === void 0 || (_this$revealedWord = _this$revealedWord.target) === null || _this$revealedWord === void 0 ? void 0 : _this$revealedWord.videoClip);
      }
    }, {
      key: "showPromptText",
      get: function get() {
        if ((0, _utils.isBlank)(this.promptWord)) {
          return false;
        }
        return !_state.DeckUI.user.hideVocabTargetUntilRevealed;
      }
    }, {
      key: "synonymDescription",
      get: function get() {
        if ((0, _utils.isBlank)(this.promptWordText)) {
          return null;
        }
        return "is a synonym of \"".concat(this.promptWordText, "\"");
      }
    }, {
      key: "synonymAssociations",
      get: function get() {
        var _this$props$card2;
        return ((_this$props$card2 = this.props.card) === null || _this$props$card2 === void 0 || (_this$props$card2 = _this$props$card2.word) === null || _this$props$card2 === void 0 || (_this$props$card2 = _this$props$card2.synonymAssociations) === null || _this$props$card2 === void 0 ? void 0 : _this$props$card2.filter(function (item) {
          var _item$synonym, _item$synonym2;
          return (0, _utils.isPresent)(item === null || item === void 0 ? void 0 : item.meaningId) && (0, _utils.isPresent)(item === null || item === void 0 || (_item$synonym = item.synonym) === null || _item$synonym === void 0 ? void 0 : _item$synonym.targetText) && (0, _utils.isPresent)(item === null || item === void 0 || (_item$synonym2 = item.synonym) === null || _item$synonym2 === void 0 || (_item$synonym2 = _item$synonym2.target) === null || _item$synonym2 === void 0 ? void 0 : _item$synonym2.videoClip);
        })) || [];
      }
    }, {
      key: "selectedSynonymAssociation",
      get: function get() {
        var _this$props$card3,
          _this4 = this;
        if ((0, _utils.isPresent)((_this$props$card3 = this.props.card) === null || _this$props$card3 === void 0 ? void 0 : _this$props$card3.synonymAssociationId)) {
          return this.synonymAssociations.find(function (item) {
            return item.id === _this4.props.card.synonymAssociationId;
          });
        }
        return null;
      }
    }, {
      key: "exampleAssociation",
      get: function get() {
        if (this.selectedSynonymAssociation) return this.selectedSynonymAssociation;
        if ((0, _utils.isBlank)(this.synonymAssociations)) return null;
        var sortedAssociations = _toConsumableArray(this.synonymAssociations).sort(function (a, b) {
          return (b.similarity || 0) - (a.similarity || 0);
        });
        return sortedAssociations.find(function (item) {
          var _item$synonym3;
          return (item === null || item === void 0 || (_item$synonym3 = item.synonym) === null || _item$synonym3 === void 0 ? void 0 : _item$synonym3.publicInVocab) !== false;
        }) || sortedAssociations[0];
      }
    }, {
      key: "correctSynonym",
      get: function get() {
        var _this$exampleAssociat;
        return ((_this$exampleAssociat = this.exampleAssociation) === null || _this$exampleAssociat === void 0 ? void 0 : _this$exampleAssociat.synonym) || null;
      }
    }, {
      key: "correctOption",
      get: function get() {
        if ((0, _utils.isBlank)(this.revealedWord)) {
          return null;
        }
        return {
          id: this.revealedWord.id || this.revealedWord.targetText,
          value: this.revealedWord.targetText,
          correct: true
        };
      }
    }, {
      key: "dictionaryWordTypeKey",
      get: function get() {
        var _this$props$card4, _this$props$card5;
        var wordTypeId = ((_this$props$card4 = this.props.card) === null || _this$props$card4 === void 0 || (_this$props$card4 = _this$props$card4.word) === null || _this$props$card4 === void 0 ? void 0 : _this$props$card4.rootWordTypeId) || ((_this$props$card5 = this.props.card) === null || _this$props$card5 === void 0 || (_this$props$card5 = _this$props$card5.word) === null || _this$props$card5 === void 0 ? void 0 : _this$props$card5.wordTypeId);
        var ids = _constants.Constants.SYNONYM_DISTRACTOR_WORD_TYPE_IDS || {};
        return Object.keys(ids).find(function (key) {
          return ids[key] === wordTypeId;
        }) || null;
      }
    }, {
      key: "mappedDistractorWords",
      get: function get() {
        var _this$props$card6, _Constants$SYNONYM_DI;
        var languageId = (_this$props$card6 = this.props.card) === null || _this$props$card6 === void 0 || (_this$props$card6 = _this$props$card6.word) === null || _this$props$card6 === void 0 ? void 0 : _this$props$card6.languageId;
        var map = (_Constants$SYNONYM_DI = _constants.Constants.SYNONYM_DISTRACTOR_WORDS_BY_LANGUAGE_AND_WORD_TYPE) === null || _Constants$SYNONYM_DI === void 0 ? void 0 : _Constants$SYNONYM_DI[languageId];
        if ((0, _utils.isBlank)(map)) {
          return [];
        }
        if (this.dictionaryWordTypeKey && (0, _utils.isPresent)(map[this.dictionaryWordTypeKey])) {
          return map[this.dictionaryWordTypeKey];
        }
        return Object.values(map).flat();
      }
    }, {
      key: "generatedDistractorOptions",
      get: function get() {
        var _this$correctOption, _this$revealedWord2, _this$revealedWord3, _this$promptWord4, _this$promptWord5, _this$selectedSynonym;
        var synonymValues = this.synonymAssociations.flatMap(function (item) {
          var _item$synonym4, _item$synonym5;
          return [item === null || item === void 0 || (_item$synonym4 = item.synonym) === null || _item$synonym4 === void 0 ? void 0 : _item$synonym4.targetTextWithDefiniteArticle, item === null || item === void 0 || (_item$synonym5 = item.synonym) === null || _item$synonym5 === void 0 ? void 0 : _item$synonym5.targetText];
        }).filter(Boolean).map(function (item) {
          return item.toLowerCase();
        });
        var excludedValues = [(_this$correctOption = this.correctOption) === null || _this$correctOption === void 0 || (_this$correctOption = _this$correctOption.value) === null || _this$correctOption === void 0 ? void 0 : _this$correctOption.toLowerCase(), (_this$revealedWord2 = this.revealedWord) === null || _this$revealedWord2 === void 0 || (_this$revealedWord2 = _this$revealedWord2.targetTextWithDefiniteArticle) === null || _this$revealedWord2 === void 0 ? void 0 : _this$revealedWord2.toLowerCase(), (_this$revealedWord3 = this.revealedWord) === null || _this$revealedWord3 === void 0 || (_this$revealedWord3 = _this$revealedWord3.targetText) === null || _this$revealedWord3 === void 0 ? void 0 : _this$revealedWord3.toLowerCase(), (_this$promptWord4 = this.promptWord) === null || _this$promptWord4 === void 0 || (_this$promptWord4 = _this$promptWord4.targetTextWithDefiniteArticle) === null || _this$promptWord4 === void 0 ? void 0 : _this$promptWord4.toLowerCase(), (_this$promptWord5 = this.promptWord) === null || _this$promptWord5 === void 0 || (_this$promptWord5 = _this$promptWord5.targetText) === null || _this$promptWord5 === void 0 ? void 0 : _this$promptWord5.toLowerCase()].concat(_toConsumableArray(synonymValues)).filter(Boolean);
        var falseMultipleChoiceOptions = (_this$selectedSynonym = this.selectedSynonymAssociation) === null || _this$selectedSynonym === void 0 ? void 0 : _this$selectedSynonym.synonymFalseSynonyms;
        var options = [];
        if ((0, _utils.isPresent)(falseMultipleChoiceOptions)) {
          options = falseMultipleChoiceOptions.split(',').map(function (item) {
            return item.trim();
          }).filter(function (item) {
            return item.length > 0;
          });
        } else if (this.mappedDistractorWords.length > 0) {
          options = this.mappedDistractorWords;
        } else {
          var _this$selectedSynonym2;
          options = (0, _utils.isPresent)((_this$selectedSynonym2 = this.selectedSynonymAssociation) === null || _this$selectedSynonym2 === void 0 ? void 0 : _this$selectedSynonym2.synonymFalseMultipleChoiceOptionsEn) ? this.selectedSynonymAssociation.synonymFalseMultipleChoiceOptionsEn.split(',').map(function (item) {
            return item.trim();
          }).filter(function (item) {
            return item.length > 0;
          }) : [];
        }
        var mappedOptions = options.filter(function (item) {
          return !excludedValues.includes(item.toLowerCase());
        }).map(function (item) {
          return {
            id: item,
            value: item,
            correct: false
          };
        });
        return (0, _lodash.shuffle)((0, _lodash.uniqBy)(mappedOptions, 'value')).slice(0, 3);
      }
    }, {
      key: "generatedSynonymOptions",
      get: function get() {
        var options = this.correctOption ? [this.correctOption].concat(_toConsumableArray(this.generatedDistractorOptions)) : _toConsumableArray(this.generatedDistractorOptions);
        return (0, _lodash.shuffle)((0, _lodash.uniqBy)(options, 'value')).slice(0, 4);
      }
    }, {
      key: "synonymOptions",
      get: function get() {
        var _this$props$card7;
        if (this.synonymOptionsCacheCardId !== ((_this$props$card7 = this.props.card) === null || _this$props$card7 === void 0 ? void 0 : _this$props$card7.id)) {
          var _this$props$card8;
          this.synonymOptionsCacheCardId = (_this$props$card8 = this.props.card) === null || _this$props$card8 === void 0 ? void 0 : _this$props$card8.id;
          this.synonymOptionsCache = [];
        }
        if ((0, _utils.isBlank)(this.synonymOptionsCache) && (0, _utils.isPresent)(this.correctOption) && (0, _utils.isPresent)(this.generatedSynonymOptions)) {
          this.synonymOptionsCache = this.generatedSynonymOptions;
        }
        return this.synonymOptionsCache;
      }
    }, {
      key: "synonymOptionsCount",
      get: function get() {
        return this.synonymOptions.length;
      }
    }, {
      key: "possibleArrowBoxes",
      get: function get() {
        return _state.DeckUI.reviewDeck ? ['select_synonym'] : ['synonym'];
      }
    }, {
      key: "currentArrowBox",
      get: function get() {
        if (this.revealed) {
          return;
        }
        if (_state.DeckUI.reviewDeck) {
          return 'select_synonym';
        }
        if (!_state.DeckUI.user.wasUiElementSeen('synonym')) {
          return 'synonym';
        }
      }
    }, {
      key: "synonymOptionsText",
      get: function get() {
        return this.synonymOptions.map(function (item) {
          return item.value || item.id;
        }).join(', ');
      }
    }, {
      key: "icons",
      get: function get() {
        var ary = [];
        if ((0, _utils.isPresent)(this.props.card.grammarTip)) {
          ary.push('grammarTip');
        }
        if (_state.DeckUI.reviewDeck && this.props.cardState.revealed) {
          ary.push('reviewDetails');
        }
        if (!_state.DeckUI.reviewDeck && this.props.cardState.revealed) {
          ary.push('toggleReview');
        }
        if (this.props.cardState.revealed) {
          ary.push('cardComments');
        }
        if (_state.DeckUI.reviewDeck && (this.props.cardState.revealed || this.props.card.showNoteBeforeReveal)) {
          ary.push('cardNote');
        }
        if (this.props.cardState.revealed) {
          ary.push('vocabCard');
        }
        return ary;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          revealed: this.revealed,
          example: this.example,
          showExampleSentence: this.showExampleSentence,
          showSentenceHintButton: this.showSentenceHintButton,
          showSentenceHint: this.showSentenceHint,
          sentenceHintShown: this.sentenceHintShown,
          showPromptText: this.showPromptText,
          promptWord: this.promptWord,
          promptWordText: this.promptWordText,
          promptWordHasVideoClip: this.promptWordHasVideoClip,
          revealedWord: this.revealedWord,
          correctSynonym: this.correctSynonym,
          correctSynonymHasVideoClip: this.correctSynonymHasVideoClip,
          synonymDescription: this.synonymDescription,
          correct: this.correct,
          userCardIsUsable: this.userCardIsUsable,
          onClick: this.onClick,
          synonymOptions: this.synonymOptions,
          synonymOptionsCount: this.synonymOptionsCount,
          multipleChoiceSelected: this.multipleChoiceSelected,
          icons: this.icons,
          possibleArrowBoxes: this.possibleArrowBoxes,
          currentArrowBox: this.currentArrowBox
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "multipleChoiceSelected", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "correct", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "example", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "example"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showSentenceHintButton", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showSentenceHintButton"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showExampleSentence", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showExampleSentence"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "revealed", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "revealed"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "userCardIsUsable", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "userCardIsUsable"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "revealedWord", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "revealedWord"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "promptWord", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "promptWord"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "promptWordText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "promptWordText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "promptWordHasVideoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "promptWordHasVideoClip"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "correctSynonymHasVideoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "correctSynonymHasVideoClip"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showPromptText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showPromptText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "synonymDescription", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "synonymDescription"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "synonymAssociations", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "synonymAssociations"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "selectedSynonymAssociation", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "selectedSynonymAssociation"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "exampleAssociation", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "exampleAssociation"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "correctSynonym", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "correctSynonym"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "correctOption", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "correctOption"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "dictionaryWordTypeKey", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "dictionaryWordTypeKey"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "mappedDistractorWords", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "mappedDistractorWords"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "generatedDistractorOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "generatedDistractorOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "generatedSynonymOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "generatedSynonymOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "synonymOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "synonymOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "synonymOptionsCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "synonymOptionsCount"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "possibleArrowBoxes", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "possibleArrowBoxes"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "currentArrowBox", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "currentArrowBox"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "synonymOptionsText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "synonymOptionsText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "icons", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "icons"), _class2.prototype), _class2)) || _class;
};
SynonymCardWrapper.displayName = 'SynonymCardWrapper';
var _default = exports["default"] = SynonymCardWrapper;